var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawNoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1 6C6.60909 6 5.4 7.34344 5.4 9V15C5.4 16.6594 4.19091 18 2.7 18C1.20909 18 0 16.6594 0 15V9C0 4.02938 3.62644 0 8.1 0H45.9C50.3719 0 54 4.02938 54 9V15C54 16.6594 52.7934 18 51.3 18C49.8066 18 48.6 16.6594 48.6 15V9C48.6 7.34344 47.3934 6 45.9 6H8.1Z",
    fill: "#BE7A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.8 48H16.2C13.2216 48 10.8 45.3094 10.8 42V9H43.2001V42C43.2001 45.3094 40.7785 48 37.8 48ZM18.9 25.5C18.9 29.6437 22.4522 33 27 33C31.4719 33 35.1 29.6437 35.1 25.5C35.1 21.3562 31.4719 18 27 18C22.4522 18 18.9 21.3562 18.9 25.5Z",
    fill: "#BE7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawNoCircle);
export default __webpack_public_path__ + "static/media/withdraw-no-circle.10782928b63d64103ba61f17281bb9b7.svg";
export { ForwardRef as ReactComponent };